import React, { useState, useEffect } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  CircularProgress
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import { fetchallcitylist, fetchchapterbyuser } from "src/utils/common";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { DownloadOutlined, RemoveRedEye } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import { downloadV2VSheet, getMemberV2VSheetReportData } from "src/api/commonapi";
import { useNavigate } from "react-router-dom";
import { Routes } from "../constant/api_url";
import CustomLoader from "src/commonComponents/CustomLoader";
import normalizeSearch from "src/utils/normalizeSearch";

export default function MembersV2VSheetReport() {
  const [downloadingId, setDownloadingId] = useState(null);

  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();

  const memberActiveType = [
    { label: "All", value: 0 },
    { label: "Active Member", value: 1 },
    { label: "De-Active Member", value: 2 }
  ];

  const memberPosition = [
    { label: "All", value: 0 },
    { label: "LT", value: 1 },
    { label: "Director", value: 2 },
    { label: "Member", value: 3 }
  ];

  const [chaptlist, setchaplist] = useState([]);
  const [searchdata, setsearchdata] = useState({
    city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : 0,
    chpt_id: 0,
    activeMemberSearchType: 0,
    activePositionType: 0,
    searchmember: ""
  });
  const [v2vSheetData, setv2vSheetData] = useState([]);
  const [newv2vSheetData, setNewv2vSheetData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  // const expo_columns = [
  //   { label: "No", key: "m_id" },
  //   { label: "Name", key: "m_name" },
  //   { label: "Business Name", key: "business_name" },
  //   { label: "Total Meeting", key: "total" },
  //   { label: "Present", key: "present" },
  //   { label: "Absent", key: "absent" }
  // ];

  const expo_csv_columns = [
    { label: "No", key: "m_v_s_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Chapter Name", key: "chpt_name" },
    { label: "Position", key: "member_new_position" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Email", key: "m_email_id" },
    { label: "Business Category", key: "business_category" },
    { label: "Created Date", key: "v2v_created_date" }
  ];

  const getV2VSheetData = async (id) => {
    navigate(`/memberv2vsheet/${id}`);
  };

  const downloadV2VSheetData = async (member_id) => {
    try {
      setDownloadingId(member_id);
      const resp = await downloadV2VSheet(member_id);

      if (resp.status === 1 && resp.filename) {
        const fileUrl = `${Routes.API_HOSTNAME}memberv2vsheet-pdf/${resp.filename}`; // Update with your actual API URL
        // Fetch the file as a blob
        const response = await fetch(fileUrl, { method: "GET" });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        // Create an invisible <a> element to trigger download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", resp.filename); // Force download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        console.error("Error: PDF not generated");
      }
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setDownloadingId(null); // Re-enable the button
    }
  };

  const columns = [
    {
      name: "No",
      selector: (row) => row.m_v_s_id,
      wrap: true,
      width: "100px",
      sortable: true
    },
    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row.m_name,
      sortable: true
    },
    {
      name: "Chapter Name",
      wrap: true,
      selector: (row) => row.chpt_name,
      sortable: true
    },
    {
      name: "Position",
      wrap: true,
      selector: (row) => (
        <div style={{ overflow: "visible", whiteSpace: "pre-line" }}>
          {row.member_new_position}
          <br />
          {row.combined_director != null && " " + row.combined_director}
        </div>
      ),
      sortable: true
    },
    {
      name: "Contact No",
      wrap: true,
      selector: (row) => row.mobile_no,
      sortable: true
    },
    {
      name: "Email",
      wrap: true,
      selector: (row) => row.m_email_id,
      sortable: true
    },
    {
      name: "Business Category",
      wrap: true,
      selector: (row) => row.business_category,
      sortable: true
    },
    {
      name: "Created Date",
      wrap: true,
      selector: (row) => row.v2v_created_date,
      sortable: true,
      width: "110px"
    },
    {
      name: "Action",
      width: "100px",
      cell: (row) => (
        <>
          <Tooltip title="View V2V Sheet">
            <IconButton
              onClick={() => {
                getV2VSheetData(row.m_id);
              }}
            >
              <RemoveRedEye color="info" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download V2V Sheet">
            <IconButton
              onClick={() => {
                downloadV2VSheetData(row.m_id);
              }}
              disabled={downloadingId === row.m_id}
            >
              {downloadingId === row.m_id ? (
                <CircularProgress size={24} color="success" />
              ) : (
                <DownloadOutlined color="success" />
              )}
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ClearSearchResult = async () => {
    setsearchdata({
      city_id:
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      chpt_id: 0,
      activeMemberSearchType: 0,
      activePositionType: 0,
      searchmember: ""
    });
  };

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };
  useEffect(async () => {
    getallcitylist();
  }, []);

  const filterData = () => {
    let selectedCityChapter =
      chaptlist &&
      chaptlist
        ?.map((chpt) => {
          if (searchdata?.city_id != 0) {
            if (chpt?.city_id == searchdata?.city_id) {
              return chpt.chpt_id;
            }
          } else {
            return chpt.chpt_id;
          }
        })
        .filter((f) => f != undefined);

    const MemberV2VList =
      v2vSheetData &&
      v2vSheetData.filter((member) => {
        if (
          (member.chpt_id == searchdata?.chpt_id ||
            searchdata?.chpt_id == 0 ||
            (member.launch_director != null && member.launch_director_at == searchdata?.chpt_id) ||
            (member.support_director != null &&
              member.support_director_at == searchdata?.chpt_id)) &&
          selectedCityChapter.length != 0 &&
          selectedCityChapter.includes(member.chpt_id) &&
          (searchdata?.activeMemberSearchType == 0
            ? member.status == 0 || member.status == 1
            : searchdata?.activeMemberSearchType == 1
              ? member.status == 1
              : member.status == 0) &&
          (searchdata?.activePositionType == 0
            ? member.type == -1 ||
              member.type == 0 ||
              member.type == 1 ||
              member.type == 2 ||
              member.type == 3 ||
              member.type == 4 ||
              member.type == 5
            : searchdata.activePositionType == 1
              ? member.type == 1 || member.type == 2 || member.type == 3 || member.type == 4
              : searchdata?.activePositionType == 2
                ? (member.launch_director != null &&
                    (member.launch_director_at == searchdata?.chpt_id ||
                      searchdata?.chpt_id == 0)) ||
                  (member.support_director != null &&
                    (member.support_director_at == searchdata?.chpt_id || searchdata?.chpt_id == 0))
                : member.type == -1 ||
                  member.type == 0 ||
                  member.type == 1 ||
                  member.type == 2 ||
                  member.type == 3 ||
                  member.type == 4 ||
                  member.type == 5) &&
          (member.m_name.toLowerCase().includes(normalizeSearch(searchdata?.searchmember)) ||
            member.business_name.toLowerCase().includes(normalizeSearch(searchdata?.searchmember)) ||
            member.business_category
              .toLowerCase()
              .includes(normalizeSearch(searchdata?.searchmember)) ||
            member.mobile_no.toLowerCase().includes(normalizeSearch(searchdata?.searchmember)))
        ) {
          return member;
        }
      });

    setNewv2vSheetData(MemberV2VList);
  };

  useEffect(() => {
    filterData();
  }, [searchdata, v2vSheetData]);

  const GetMemberV2VSheetData = async () => {
    setIsLoading(true);
    let res = await getMemberV2VSheetReportData(loginUser.city_id, loginUser.u_type);
    setIsLoading(false);
    if (res?.data?.length > 0) {
      setv2vSheetData(res?.data);
    } else {
      setv2vSheetData([]);
    }
  };
  useEffect(async () => {
    GetMemberV2VSheetData();
  }, []);

  return (
    <>
      <Page title="Members V2V Sheet Report | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Member's V2V Sheet Report
            </Typography>
            <Button className="btn btn-export">
              <CSVLink
                data={v2vSheetData}
                headers={expo_csv_columns}
                filename={"Member's V2V Sheet Data.csv"}
                className="btn btn-primary test"
                target="_blank"
              >
                Export CSV
              </CSVLink>
            </Button>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={2} alignItems={"end"}>
              <Grid item xs={2}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        city_id: e.value,
                        chpt_id: 0
                      });
                    }}
                    value={
                      searchdata.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              searchdata.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchdata?.city_id != 0) {
                              if (searchdata?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchdata.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                          chaptlist.map((c) => {
                            if (c.chpt_id == searchdata.chpt_id) {
                              return {
                                value: c.chpt_id,
                                label: c.chpt_name
                              };
                            }
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Member Active Type</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        if (option.value == searchdata.activeMemberSearchType) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, activeMemberSearchType: e.value });
                    }}
                    options={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Select Position</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={memberPosition.map((c) => {
                      if (c.value == searchdata.activePositionType) {
                        return { value: c.value, label: c.label };
                      }
                    })}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        activePositionType: e.value
                      });
                    }}
                    options={memberPosition}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Search Member</label>
                  <TextField
                    style={{ marginTop: "0px" }}
                    autoComplete="off"
                    type="text"
                    label="Search Member"
                    size="small"
                    name="search"
                    value={searchdata?.searchmember ? searchdata?.searchmember : ""}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        searchmember: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid xs={1} item sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card style={{ marginTop: "15px" }}>
            {v2vSheetData && (
              <>
                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={newv2vSheetData}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>
      </Page>
    </>
  );
}
